import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import React from "react";
import ExpensesAndRevenuesReportsViewModel from "viewModels/finance/expensesAndRevenuesReports/expensesAndRevenuesReportsViewModel";
import Tabs from "../../common/tabs";

const ExpensesAndRevenuesReportsView: ViewComponent<ExpensesAndRevenuesReportsViewModel> = observer(({ vm }) => {
  return (
    <>
      <h3 className="mb-6">{vm.name}</h3>
      <Tabs vm={vm} />
    </>
  );
});

registerView(ExpensesAndRevenuesReportsView, ExpensesAndRevenuesReportsViewModel);
